(() => {
  const PARAM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'utm_id', 'referrer_template', 'fbc', 'fbp', 'gclid', 'OutbrainClickId']
  const PART_PARAM_KEYS = ['trc_'];
  const COOKIE_PREFIX = '_trk_';

  function handleTrackingIds() {
    const urlParams = new URLSearchParams(window.location.search);
    const newIds = [];
    const changedAttributes = {};

    const partnerParamKeys = (window.theme?.tracking?.partners ?? [])
      .flatMap(p => p.params)
      .map(k => k.trim())
      .filter((k, i, arr) => arr.indexOf(k) === i);

    urlParams.forEach((value, key) => {
      const isParamKey = PARAM_KEYS.includes(key);
      const isPartnerKey = !isParamKey && partnerParamKeys.includes(key);
      const isPartialKey = PART_PARAM_KEYS.some(prefix => key.startsWith(prefix));

      if (!isParamKey && !isPartnerKey && !isPartialKey) return;

      setCookie(COOKIE_PREFIX + key, value);

      if (isParamKey || isPartialKey) {
        newIds.push(key);
        changedAttributes[key] = value;
      }
    });

    const fbclid = urlParams.get('fbclid');
    if (fbclid) {
      const fbc = generateFbc(fbclid);
      newIds.push('zuckClick');
      changedAttributes['zuckClick'] = fbc;
      setCookie(COOKIE_PREFIX + 'zuckClick', fbc);
    }

    if (!getCookie(COOKIE_PREFIX + 'zuckBro')) {
      const fbp = generateFbp();
      newIds.push('zuckBro');
      changedAttributes['zuckBro'] = fbp;
      setCookie(COOKIE_PREFIX + 'zuckBro', fbp);
    }


    if (window.Shopify?.analytics?.publish) {
      window.Shopify.analytics.publish('set_relevant_ids', { ids: newIds });
    }

    if (Object.keys(changedAttributes).length > 0) {
      updateCartAttributes(changedAttributes).then();
    }
  }

  function setupLinkTracking() {
    const links = document.querySelectorAll('a[href]');
    const dmnGroup = Array.isArray(window.theme?.tracking?.dmn_group) ? window.theme.tracking.dmn_group : [];
    const partners = Array.isArray(window.theme?.tracking?.partners) ? window.theme.tracking.partners : [];
    if (dmnGroup.length === 0 && partners.length === 0) return;

    links.forEach(async link => {
      const href = link.getAttribute('href');
      if (!href || href.startsWith('#') || href.startsWith('javascript') || href.startsWith('mailto:') || href.startsWith('tel:')) return;

      let url;
      try {
        url = new URL(href, window.location.origin);
      } catch (e) {
        return;
      }

      const isExternal = url.hostname !== window.location.hostname;
      if (!isExternal) return;

      const domain = url.hostname.replace(/^www\./, '');
      const hash = await sha256Hex(domain);

      if (dmnGroup.includes(hash)) {
        link.href = getTrackingUrl(url);
        return;
      }

      const partner = partners.find(p => p.hash === hash);
      if (partner) {
        link.href = getTrackingUrl(url, partner.params.map(k => k.trim()));
      }
    });
  }

  function getTrackingUrl(baseUrl, allowedParams = null) {
    const params = new URLSearchParams();
    const keysToUse = allowedParams ?? PARAM_KEYS;

    keysToUse.forEach(key => {
      const value = getCookie(COOKIE_PREFIX + key);
      if (value) params.set(key, value);
    });

    if (!allowedParams) {
      document.cookie.split(';').forEach(cookieStr => {
        const [rawName, rawValue] = cookieStr.split('=');
        const name = rawName?.trim();
        const value = decodeURIComponent(rawValue || '');
        if (PART_PARAM_KEYS.some(prefix => name.startsWith(COOKIE_PREFIX + prefix))) {
          params.set(name.slice(COOKIE_PREFIX.length), value);
        }
      });

      if (typeof Kameleoon !== "undefined") {
        const kameleoonCode = Kameleoon?.API?.Visitor?.code;
        if (kameleoonCode) {
          params.set('kameleoon_visitor_code', kameleoonCode);
        }
      }
    }

    const url = new URL(baseUrl);
    for (const [key, value] of params.entries()) {
      url.searchParams.set(key, value);
    }

    if (!allowedParams) {
      const referrerTemplate = window.theme?.template?.suffix ?? null;
      if (referrerTemplate) {
        url.searchParams.set('referrer_template', referrerTemplate);
      }
    }

    return url.toString();
  }

  function generateFbc(fbclid) {
    const timestamp = Date.now();
    return `${timestamp}.${fbclid}`;
  }

  function generateFbp() {
    const timestamp = Date.now();
    const rand = (() => {
      if (typeof crypto !== "undefined" && crypto.getRandomValues) {
        const buf = new Uint32Array(1);
        crypto.getRandomValues(buf);
        const n = (buf[0] % 9000000000) + 1000000000;
        return String(n);
      }
      return String(Math.floor(Math.random() * 9000000000) + 1000000000);
    })();

    return `${timestamp}.${rand}`;
  }

  function getCookie(name) {
    return document.cookie
      .split('; ')
      .map(c => c.split('='))
      .find(([key]) => key === name)?.[1] ?? null;
  }

  function setCookie(name, value, { days = 90 } = {}) {
    const expires = new Date();
    expires.setDate(expires.getDate() + days);

    let cookie = `${name}=${encodeURIComponent(value)}; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
    if (location.protocol === 'https:') cookie += '; Secure';
    document.cookie = cookie;
  }

  async function updateCartAttributes(attributes) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      body: JSON.stringify({
        attributes,
      }),
      keepalive: true,
      credentials: 'same-origin',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      }
    });
  }

  async function sha256Hex(str) {
    const encoder = new TextEncoder();
    const data = encoder.encode(str);
    const hashBuffer = await crypto.subtle.digest('SHA-256', data);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    return hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
  }

  handleTrackingIds();
  setupLinkTracking();

  // Re-run link tracking when Kameleoon becomes available to include visitor code
  if (typeof Kameleoon !== 'undefined' && Kameleoon.API?.Visitor) {
    // Kameleoon already loaded, links are already set up with the code
  } else {
    window.addEventListener('Kameleoon::Started', function () {
      setupLinkTracking();
    });
  }
})()